import { Box, Typography, Stack } from "@mui/material";

const HowToClaim = () => {
  return (
    <Box sx={{ px: 2, py: 4 }}>
      {/* Title */}
      <Typography variant="h6" fontWeight="bold" mb={3}>
        How to claim
      </Typography>

      {/* Step 1 */}
      <Box mb={4}>
        <Box
          component="img"
          src="https://res.cloudinary.com/dtear00ob/image/upload/v1744253099/projectImages/step1-0d1651d7-4ded-46b3-a219-331f1717aca2.png"
          alt="Step 1"
          width="100%"
          borderRadius={2}
          mb={2}
        />
        <Typography variant="subtitle1" fontWeight="bold" mb={1}>
          Step 1
        </Typography>
        <Typography variant="body2">
          Open your email.
        </Typography>
      </Box>

      {/* Step 2 */}
      <Box mb={4}>
        <Box
          component="img"
          src="https://res.cloudinary.com/dtear00ob/image/upload/v1744253091/projectImages/step2-be1e4f0f-e327-42d6-9b14-f731d92b020a.png"
          alt="Step 2"
          width="100%"
          borderRadius={2}
          mb={2}
        />
        <Typography variant="subtitle1" fontWeight="bold" mb={1}>
          Step 2
        </Typography>
        <Typography variant="body2">
          Look for the confirmation email from us.
        </Typography>
      </Box>

      {/* Step 3 */}
      <Box mb={4}>
        <Box
          component="img"
          src="https://res.cloudinary.com/dtear00ob/image/upload/v1744253107/projectImages/step3-abb6218c-ec01-4f26-8342-3b2a32c336bb.png"
          alt="Step 3"
          width="100%"
          borderRadius={2}
          mb={2}
        />
        <Typography variant="subtitle1" fontWeight="bold" mb={1}>
          Step 3
        </Typography>
        <Typography variant="body2">
          Present the email to the event admin to claim your prize
        </Typography>
      </Box>
    </Box>
  );
};

export default HowToClaim;
